/**
 * Auth API — 对应后端 r_auth.py (30个端点中的认证相关)
 *
 * 端点:
 *   POST /api/auth/login
 *   POST /api/auth/logout
 *   POST /api/auth/refresh
 *   GET  /api/auth/check
 */
import apiClient from './index'

export const authApi = {
  async login(username: string, password: string) {
    const res = await apiClient.post('/auth/login', { username, password })
    return res.data
  },

  async logout(headers?: Record<string, string>) {
    const res = await apiClient.post('/auth/logout', {}, { headers })
    return res.data
  },

  async check(_token?: string | null) {
    // Legacy callers may still pass a token, but Teacher Web authentication is
    // intentionally cookie-only so a stale in-memory token cannot shadow it.
    const res = await apiClient.get('/auth/check')
    return res.data
  },

  async refresh(refreshToken: string) {
    const res = await apiClient.post('/auth/refresh', { refresh_token: refreshToken })
    return res.data
  },

  // ★ Fix: 邀请码注册此前缺失该方法，导致 LoginView 调用报 "registerWithInvite is not a function"。
  //   后端 /auth/register 强制要求图形验证码，需一并提供 captcha_token/captcha_answer。
  async getCaptcha() {
    const res = await apiClient.get('/auth/captcha')
    return res.data
  },

  async registerWithInvite(payload: Record<string, unknown>) {
    const res = await apiClient.post('/auth/register', {
      username: payload.username,
      password: payload.password,
      name: payload.name,
      invite_code: payload.invite_code,
      captcha_token: payload.captcha_token || '',
      captcha_answer: payload.captcha_answer || '',
    })
    return res.data
  },
}
